import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getMonths } from "../../slices/codeBookSlice";

export const useGetMonths = () => {
  const months = useSelector((state: RootState) => state.codeBook.months);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMonths());
  }, [dispatch]);

  return months;
};
